import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import Box from '@mui/material/Box';
import ViewContentLogo from './ViewContentLogo';

class ViewContent extends React.Component {

  render () {
    const { classes, children, classesContent, displayLogo } = this.props;
    return (
      <Box className={clsx(classes.content, classesContent)}>
        { displayLogo && (
          <Box className={classes.logo}>
            <ViewContentLogo />
          </Box>
        ) }
        { children }
      </Box>
    )
  }
}

const styles = theme => ({
  content: {
    zIndex: theme.zIndex.drawer + 1,
    padding: theme.spacing(2),
    backgroundColor: '#ffffff',
    border: 'none',
    borderRadius: '3px',
  },
  logo: {
    marginBottom: theme.spacing(3),
  },
});

ViewContent.propTypes = {
  classesContent: PropTypes.string,
  displayLogo: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(ViewContent);
